// extracted by mini-css-extract-plugin
module.exports = {"tabs":"-sku-tabs-tabs-3fgqPz-"};